import React from 'react';

import { Box, Typography, Button, LinearProgress } from '@mui/material';
import CustomDialog from 'src/components/UI/dialog/CustomDialog';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const ClinicalNoteDeleteModal = (props) => {
  const t = useAutoTranslation();

  const { handleCloseModal, loading, onConfirm, title, content, open } = props;

  return (
    <CustomDialog
      open={open}
      handleClose={handleCloseModal}
      title={title}
      titleAppearance={'warning'}
      minHeight={150}
      allowBackgroundClose={handleCloseModal}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 'bold'
          }}
        >
          {content}
        </Typography>

        {loading && (
          <Box sx={{ width: '100%', pt: 1 }}>
            <Typography
              sx={{
                fontWeight: 'bold',
                py: 1
              }}
            >
              {t('Deletion In Progress')}
            </Typography>
            <LinearProgress />
          </Box>
        )}

        <Box
          sx={{
            pt: 3
          }}
        >
          <hr />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 3,
            pt: 2
          }}
        >
          <Button
            onClick={handleCloseModal}
            color="secondary"
            variant="outlined"
            disabled={loading}
          >
            {t('Cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {t('Confirm Deletion')}
          </Button>
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default ClinicalNoteDeleteModal;
